export default __webpack_public_path__ + "static/media/waitNextRound.30e09c56.mp3";